import PropTypes from 'prop-types';
import { map } from '@/helpers/lodash';
import ButtonCTA from '@/components/component-library/Button/CTA';
import Gradient, { GRADIENT_POSITION_BOTTOM, GRADIENT_POSITION_TOP } from '@/components/app/Gradient';
import Overlay from '@/components/app/Overlay';
import Text, { FONT_SIZE_090 } from '@/components/component-library/Text';
import { classes } from '@/helpers/styling';

const OVERLAY_BACKGROUND_STYLE = { opacity: 0.9 };

const GRADIENT_TOP_WRAPPER_STYLE = { top: '80px' };

const GRADIENT_BOTTOM_WRAPPER_STYLE = { bottom: '120px' };

const FilterMenu = ({
  filterOptions,
  title,
  onClickFilter,
  onClose,
  isOpen,
  selectedFilterId,
  children
}) => {
  const overlayClassName = classes(
    'transition-slide-from-bottom',
    { '--is-open': isOpen },
    isOpen ? '--is-transitioned-03' : '--is-transitioning-03'
  );

  return (
    <Overlay
      backgroundStyle={OVERLAY_BACKGROUND_STYLE}
      commonClassName={overlayClassName}
      zIndex={105}
    >
      <div className='filter-menu-wrapper'>
        <div className='filter-menu'>
          {title && (
            <div className='header-footer-section'>
              <Text bold size={FONT_SIZE_090} useHeaderFont>
                {title}
              </Text>
            </div>
          )}
          {children ? (
            <div className='content-wrapper'>
              {children}
            </div>
          ) : (
            <div className='scrolling-content-wrapper'>
              <Gradient
                breadth='15%'
                gradientBreadth='100%'
                position={GRADIENT_POSITION_TOP}
                wrapperStyle={GRADIENT_TOP_WRAPPER_STYLE}
              />
              <div className='scrolling-content'>
                <div className='list-options'>
                  {
                    map(filterOptions, ({ id, value, slug }, index) => (
                      <Text
                        bold
                        className={classes('scroller-option', { '--is-selected': selectedFilterId === id })}
                        key={id || index}
                        onClick={() => onClickFilter({ id, value, slug })}
                        size={FONT_SIZE_090}
                        useHeaderFont
                      >
                        {value}
                      </Text>
                    ))
                  }
                </div>
              </div>
              <Gradient
                breadth='15%'
                directionReverse
                gradientBreadth='100%'
                position={GRADIENT_POSITION_BOTTOM}
                wrapperStyle={GRADIENT_BOTTOM_WRAPPER_STYLE}
              />
            </div>
          )}
          <div className='header-footer-section'>
            <ButtonCTA onClick={onClose}>
              Close
            </ButtonCTA>
          </div>
        </div>
      </div>
    </Overlay>
  );
};

FilterMenu.propTypes = {
  filterOptions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.string
  })),
  title: PropTypes.string,
  isOpen: PropTypes.bool,
  onClickFilter: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedFilterId: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

FilterMenu.defaultProps = {
  title: '',
  filterOptions: [],
  selectedFilterId: undefined,
  isOpen: false,
  children: null
};

export default FilterMenu;
